import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream border-y border-sage-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22etwkfukigth">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi7cbflvxlt">
          <p className="text-leaf font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yejliorx507r">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-forest" data-id="element-24" data-mp="15pw3d22guqyf">
            <span className="text-leaf" data-id="element-25" data-mp="1jgiqdwyv6seo">5</span> PRACTICAL HYDROPONICS BONUSES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-26" data-mp="1eqapu4r62c3i">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-sage-200 rounded-2xl p-8 shadow-sm shadow-forest/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="r082g1y75ub8" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-forest text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-28" data-mp="2ogpsca7pxzgn">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-sage-50 border border-sage-300 rounded-full flex items-center justify-center text-leaf mb-4" data-id="element-29" data-mp="1qvlacw1pfnee">
                <Gift size={24} data-id="element-30" data-mp="20r54pe0mee11" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-forest" data-id="element-31" data-mp="20trfdmit59nh">{bonus.title}</h3>
              <p className="text-leaf text-sm font-semibold mb-4 border-l-4 border-leaf pl-4" data-id="element-32" data-mp="25o54j76vmkjp">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-charcoal text-sm mb-4 leading-relaxed" data-id="element-33" data-mp="3h3tsa0ryfnlk">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-forest font-semibold text-sm mb-3" data-id="element-34" data-mp="1c395puncawgp">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-35" data-mp="1q323ub174eyp">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-36" data-mp="tevtr8li8ud1">
                        <CheckCircle2 size={16} className="text-leaf shrink-0 mt-0.5" data-id="element-37" data-mp="175r5csne1pkb" />
                        <span className="text-charcoal text-sm" data-id="element-38" data-mp="12eistnqrho2x">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-forest font-semibold text-sm mb-3" data-id="element-39" data-mp="amjp2f7dpgzq">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-40" data-mp="5a4n1c6ptyo2">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-forest font-semibold text-sm bg-sage-50 border border-sage-200 rounded-lg px-3 py-2" data-id="element-41" data-mp="3mrnt0rbdbz09">
                        {bullet}
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-42" data-mp="o6mj25slkkq4">
                {bonus.system && <div data-id="element-43" data-mp="9dsttsniwq89">
                    <p className="text-forest font-semibold text-sm mb-2" data-id="element-44" data-mp="eaj8qcnldfs3">{bonus.systemLabel}</p>
                    <p className="text-forest font-bold text-xs sm:text-sm tracking-wide bg-lime-soft border-l-4 border-leaf rounded-lg px-3 py-2" data-id="element-45" data-mp="2u27443myj08s">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-sage-50 border border-sage-200 border-l-4 border-l-leaf rounded-xl p-4" data-id="element-46" data-mp="3f9zl4fkb5zow">
                    <span className="text-forest font-bold block mb-1" data-id="element-47" data-mp="35i3pdb5p2lnu">RESULT</span>
                    <p className="text-charcoal text-sm" data-id="element-48" data-mp="35g0o1uz3d63t">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-sage-200" data-id="element-49" data-mp="20lesvyjf0jq">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-forest font-extrabold text-base tracking-wide' : 'text-forest font-semibold text-sm italic'} data-id="element-50" data-mp="3t5v1adnbowol" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}